// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.columnMain {
  width: 338px;
  display: flex;
  flex-direction: column;
}

.columnMain:first-child {
  margin-right: 100px;
}

.columnMain:nth-last-child(2) {
  margin-right: 100px;
}

.title {
  color: blue;
  font-weight: 900;
}

.customize-view-dialog {
  width: 1080px;
  height: 569px;
  border-radius: 20px;
}
.customize-view-dialog .p-dialog-header {
  border-radius: 20px 20px 0 0;
}
.customize-view-dialog .p-dialog-header1 {
  padding: 0 !important;
  font-weight: 500;
  font-size: 20px;
  line-height: 24.38px;
  color: #003da5;
}
.customize-view-dialog .dragAndDropColumnPaddingRight {
  margin-right: 70px;
}
.customize-view-dialog .dragAndDropColumnData {
  font-size: 14px;
  line-height: 17px;
  font-weight: 500;
  color: #003da5;
  padding-bottom: 8px;
}
.customize-view-dialog .dragAndDropColumn {
  border: 1px solid rgb(172, 172, 172);
  border-radius: 8px;
  width: 272px;
  height: 344px;
  padding: 4px 12px;
  overflow-y: auto;
  cursor: pointer;
}
.customize-view-dialog .p-dialog-content {
  padding: 0 32px 20px 32px !important;
  border-radius: 0 0 20px 20px;
}
.customize-view-dialog .dragAndDrop100 {
  width: 100%;
  height: 100%;
}
.customize-view-dialog .dsbp-form-buttons {
  padding: 20px 20px 12px 20px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.confirmPPFA {
  padding: 16px 0 1px 0 !important;
  text-align: right;
}
.confirmPPFA .p-button {
  margin: 0 !important;
}

.test {
  color: red;
}`, "",{"version":3,"sources":["webpack://./src/components/common/CustomizeView/index.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EAKA,aAAA;EACA,sBAAA;AAHF;;AAMA;EACE,mBAAA;AAHF;;AAMA;EACE,mBAAA;AAHF;;AAMA;EACE,WAAA;EACA,gBAAA;AAHF;;AAMA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;AAHF;AAKE;EAEE,4BAAA;AAJJ;AAOE;EACE,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;AALJ;AAQE;EACE,kBAAA;AANJ;AASE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAPJ;AAUE;EACE,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AARJ;AAWE;EACE,oCAAA;EACA,4BAAA;AATJ;AAYE;EACE,WAAA;EACA,YAAA;AAVJ;AAaE;EACE,4BAAA;EACA,+BAAA;EACA,gCAAA;AAXJ;;AAeA;EACE,gCAAA;EACA,iBAAA;AAZF;AAcE;EACE,oBAAA;AAZJ;;AAiBA;EACE,UAAA;AAdF","sourcesContent":[".columnMain {\n  width: 338px;\n  // margin: 8px;\n  // border-radius: 2px;\n  // border: 1px solid red;\n  // background-color: rgb(248, 244, 244);\n  display: flex;\n  flex-direction: column;\n}\n\n.columnMain:first-child {\n  margin-right: 100px;\n}\n\n.columnMain:nth-last-child(2) {\n  margin-right: 100px;\n}\n\n.title {\n  color: blue;\n  font-weight: 900;\n}\n\n.customize-view-dialog {\n  width: 1080px;\n  height: 569px;\n  border-radius: 20px;\n\n  .p-dialog-header {\n    //padding: 20px 32px !important;\n    border-radius: 20px 20px 0 0;\n  }\n\n  .p-dialog-header1 {\n    padding: 0 !important;\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 24.38px;\n    color: #003da5;\n  }\n\n  .dragAndDropColumnPaddingRight {\n    margin-right: 70px;\n  }\n\n  .dragAndDropColumnData {\n    font-size: 14px;\n    line-height: 17px;\n    font-weight: 500;\n    color: #003da5;\n    padding-bottom: 8px;\n  }\n\n  .dragAndDropColumn {\n    border: 1px solid rgba(172, 172, 172, 1);\n    border-radius: 8px;\n    width: 272px;\n    height: 344px;\n    padding: 4px 12px;\n    overflow-y: auto;\n    cursor: pointer;//Added for 4047 scroll issue\n  }\n\n  .p-dialog-content {\n    padding: 0 32px 20px 32px !important;\n    border-radius: 0 0 20px 20px;\n  }\n\n  .dragAndDrop100 {\n    width: 100%;\n    height: 100%;\n  }\n\n  .dsbp-form-buttons {\n    padding: 20px 20px 12px 20px;\n    border-bottom-left-radius: 20px;\n    border-bottom-right-radius: 20px;\n  }\n}\n\n.confirmPPFA {\n  padding: 16px 0 1px 0 !important;\n  text-align: right;\n\n  .p-button {\n    margin: 0 !important;\n  }\n}\n\n// Task\n.test {\n  color: red;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
